const team2024 = {
  title: "2024",
  members: [
    {
      name: "message.team.management",
      members: [
        {
          img: "/static/team/members/shawn_killeen.jpg",
          fullName: "Shawn Killeen",
          role: "message.team.roles.captain",
          mail: "s.killeen.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/shawnkilleen/",
        },
        {
          img: "/static/team/members/jean_carlo.jpg",
          fullName: "Jean-Carlo Doray",
          role: "message.team.roles.technical-director",
          mail: "jc.doray.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/jean-carlo-doray-b8614423b",
      },
      ],
    },
    {
      name: "message.team.aerodynamic",
      members: [
        {
          img: "/static/team/members/eline_houri.jpg",
          fullName: "Eline Houri",
          role: "message.team.roles.lead-aerodynamics",
          mail: "e.houri.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/eline-houri-0961aa220/",
        },
        {
          img: "/static/team/members/2024/Hugues_Perrin.jpg",
          fullName: "Hugues Perrin",
          role: "",
          mail: "h.perrin.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/hugues-perrin-674924194/",
        },
        {
          img: "/static/team/members/2024/Hugo_Le_Guillous.jpg",
          fullName: "Hugo Le Guillous",
          role: "",
          mail: "h.leguillous.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/hugo-le-guillous-1063091a6/",
        },
        {
          img: "/static/team/members/2024/Nathan_Piha.jpg",
          fullName: "Nathan	Piha",
          role: "",
          mail: "n.piha.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/nathan-piha-7357722ab/",
        },
        {
          img: "",
          fullName: "Jules Berrafato",
          role: "",
          mail: "",
          linkedin: "https://www.linkedin.com/in/jules-berrafato-08281122b/",
        },
        {
          img: "/static/team/members/2024/Adrien_Huyghebaert.jpg",
          fullName: "Adrien	Huyghebaert",
          role: "",
          mail: "a.huyghebaert.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/adrien-huyghebaert/",
        },
      ],
    },
    {
      name: "message.team.chassis",
      members: [
        {
          img: "/static/team/members/etienne_paillereau.jpg",
          fullName: "Etienne Paillereau",
          role: "message.team.roles.lead-chassis",
          mail: "e.paillereau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
        },
        {
          img: "/static/team/members/mathilde_vigon.jpg",
          fullName: "Mathilde Vigon",
          role: "",
          mail: "m.vigon.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/mathilde-vigon-376526205/",
        },
        {
          img: "/static/team/members/2024/Guillaume_Beaufort-Samson.jpg",
          fullName: "Guillaume Beaufort-Samson",
          role: "",
          mail: "g.beaufortsamson.formule.ets@gmail.com",
          linkedin:"https://www.linkedin.com/in/guillaume-beaufort-samson-3110952a/",
        },
      ],
    },
    {
      name: "message.team.dynamics",
      members: [
        {
          img: "/static/team/members/charles_barette.jpg",
          fullName: "Charles Barette",
          role: "message.team.roles.lead-dynamic",
          mail: "c.barette.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/charles-barette/",
        },
        {
          img: "/static/team/members/lea_tonini.jpg",
          fullName: "Léa Tonini",
          role: "",
          mail: "l.tonini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/l%C3%A9a-tonini-517780196/",
        },
      ],
    },
    {
      name: "message.team.electronics",
      members: [
        {
          img: "/static/team/members/alexis_st-pierre.jpg",
          fullName: "Alexis St-Pierre",
          role: "message.team.roles.lead-electronic",
          mail: "a.stpierre.formule.ets@gmail.com",
          linkedin:"https://www.linkedin.com/in/alexis-st-pierre-48ab7a230/",
        },
        {
          img: "/static/team/members/felix_groleau.jpg",
          fullName: "Félix Groleau",
          role: "",
          mail: "f.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/f%C3%A9lix-groleau-28b5b3231",
        },
        {
          img: "/static/team/members/jerome_bolduc.jpg",
          fullName: "Jérôme Bolduc",
          role: "",
          mail: "j.bolduc.formule.ets@gmail.com",
          linkedin:"https://www.linkedin.com/in/j%C3%A9r%C3%B4me-bolduc-7083191b1/",
        },
        {
          img: "/static/team/members/shawn_killeen.jpg",
          fullName: "Shawn Killeen",
          role: "",
          mail: "s.killeen.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/shawnkilleen/",
        },
        {
          img: "",
          fullName: "Alexis Acuautla Garcia",
          role: "",
          mail: "",
          linkedin: "",
        },
      ],
    },
    {
      name: "message.team.drivetrain",
      members: [
        {
          img:"/static/team/members/alek_cyr.jpg",
          fullName:"Alek Cyr",
          role:"message.team.roles.lead-drivetrain",
          mail:"a.cyr.formule.ets@gmail.com",
          linkedin:"https://www.linkedin.com/in/alek-cyr-9397b6192"
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/charles_deschenes.jpg",
          fullName: "Charles Deschenes",
          role: "",
          mail: "c.deschenes.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/charles-deschenes-b1970829b/",
        },
        {
          img: "/static/team/members/2024/Francis_Bigaouette.jpg",
          fullName: "Francis Bigaouette",
          role: "",
          mail: "f.bigaouette.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/francis-bigaouette-a9b5bb24a/",
        },
        {
          img: "/static/team/members/2024/Martin_Lex.jpg",
          fullName: "Martin Lex",
          role: "",
          mail: "m.lex.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/martin-lex-b9a896150/",
        },
      ],
    },
    {
      name: "message.team.powertrain",
      members: [
        {
            img: "/static/team/members/zacharie_morin.jpg",
            fullName: "Zacharie Morin",
            role: "message.team.roles.lead-powertrain",
            mail: "z.morin.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/zacharie-morin-ba8703293/",
        },
        {
            img: "/static/team/members/jean_carlo.jpg",
            fullName: "Jean-Carlo Doray",
            role: "",
            mail: "jc.doray.formule.ets@gmail.com",
            linkedin: "https://www.linkedin.com/in/jean-carlo-doray-b8614423b",
        },
        {
          img: "/static/team/members/alexis_st-pierre.jpg",
          fullName: "Alexis St-Pierre",
          role: "",
          mail: "a.stpierre.formule.ets@gmail.com",
          linkedin:"https://www.linkedin.com/in/alexis-st-pierre-48ab7a230/",
        },
        {
          img: "/static/team/members/2024/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin:"https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
      ],
    },
    {
      name: "message.team.control",
      members: [
        {
          img: "/static/team/members/felix_groleau.jpg",
          fullName: "Félix Groleau",
          role: "",
          mail: "f.groleau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/f%C3%A9lix-groleau-28b5b3231",
        },
      ],
    },
    {
      name: "message.team.machining",
      members: [
        {
          img: "/static/team/members/2024/Thomas_Lefebvre.jpg",
          fullName: "Thomas Lefebvre",
          role: "",
          mail: "t.lefebvre.formule.ets@gmail.com",
          linkedin:"https://ca.linkedin.com/in/thomas-lefebvre-31a161253/",
        },
        {
          img: "/static/team/members/maxim_brasseur.jpg",
          fullName: "Maxim Brasseur",
          role: "",
          mail: "m.brasseur.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/maximbrasseur/",
        },
        {
          img: "/static/team/members/etienne_paillereau.jpg",
          fullName: "Etienne Paillereau",
          role: "",
          mail: "e.paillereau.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/etienne-paillereau-746855203",
        },
      ],
    },
    {
      name: "message.team.driverless",
      members: [
        {
          img: "/static/team/members/raphael_roumat.jpg",
          fullName: "Raphaël Roumat",
          role: "message.team.roles.lead-driverless",
          mail: "r.roumat.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/rapha%C3%ABl-roumat-5a3015253/",
        },
        {
          img: "/static/team/members/nicolas_gaulin-metivier.jpg",
          fullName: "Nicolas Gaulin-Métivier ",
          role: "",
          mail: "n.gaulinmetivier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/nicolas-gaulin-m%C3%A9tivier-50850a258/",
        },
        {
          img: "/static/team/members/2024/Erwan_Manach.jpg",
          fullName: "Erwan Manach",
          role: "",
          mail: "e.manach.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/erwan-manach-390397236/",
        },
      ],
    },
    {
      name: "message.team.external_relationship",
      members: [
        {
          img: "",
          fullName: "Elsa Beaudet",
          role: "message.team.roles.lead-external-relationship",
          mail: "e.beaudet.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/elsa-beaudet-818b681b8/",
        },
        {
          img: "/static/team/members/mathilde_vigon.jpg",
          fullName: "Mathilde Vigon",
          role: "",
          mail: "m.vigon.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/mathilde-vigon-376526205/",
        },
        {
          img: "/static/team/members/lea_tonini.jpg",
          fullName: "Léa Tonini",
          role: "",
          mail: "l.tonini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/l%C3%A9a-tonini-517780196/",
        },
        {
          img: "/static/team/members/melina_gasparini.jpg",
          fullName: "Mélina Gasparini",
          role: "",
          mail: "m.gasparini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/melina-gasparini-cpi-cep-631991141/",
        },
        {
          img: "/static/team/members/2024/Audrey_Barrier.jpg",
          fullName: "Audrey Barrier",
          role: "",
          mail: "a.barrier.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/audrey-barrier-72279a234/",
        },
        {
          img: "/static/team/members/2024/Hugues_Perrin.jpg",
          fullName: "Hugues Perrin",
          role: "",
          mail: "h.perrin.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/hugues-perrin-674924194/",
        },
        {
          img: "/static/team/members/2024/Alexandre_Remillard.jpg",
          fullName: "Alexandre Rémillard",
          role: "",
          mail: "a.remillard.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/alexandre-r%C3%A9millard-68b686260/",
        },
      ],
    },
    {
      name: "message.team.statics",
      members: [
        {
          img: "/static/team/members/lea_tonini.jpg",
          fullName: "Léa Tonini",
          role: "message.team.roles.lead-cost",
          mail: "l.tonini.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/l%C3%A9a-tonini-517780196/",
        },
        {
          img: "/static/team/members/2024/Erwan_Manach.jpg",
          fullName: "Erwan Manach",
          role: "message.team.roles.lead-business",
          mail: "e.manach.formule.ets@gmail.com",
          linkedin: "https://www.linkedin.com/in/erwan-manach-390397236/",
        },
      ],
    },
  ],
};

export default team2024;
